import { APIModel } from '@shared/interfaces';

import { PollingStatus, StatusProvider } from '@/tax/models';

export class DocImport implements APIModel {
    id = -1;
    periodId = -1;
    folderId = -1;
    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    progress = 0;
    progressMessage?: string;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.periodId = data.period_id ?? -1;
        this.folderId = data.folder_id ?? -1;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.progress = data.progress ?? 0;
        this.progressMessage = data.progress_message ?? undefined;
        return this;
    }

    serialize(): any {
        return {
            'period_id': this.periodId,
            'folder_id': this.folderId,
        };
    }
}
